import { useEffect, useState } from 'react'
import Default from 'components/layouts/Default/Default';
import NotificationPage from 'components/templates/Notifications/NotificationPage';

const Notifications = () => {

  return (
    <Default>
        <div className="row">

          <div className="col-12 text-white d-flex">
            <h3 className="pb-2">Notifications</h3>
          </div>
          <div className="col-12">
            <NotificationPage />
          </div>
          
        </div>

    </Default>
  )
}
// const dashboard = () => {
//     return (<div>Dashboard</div>)
// }
export default (Notifications);